import { useContext } from 'react';
import { useQuery } from 'react-query';
import { FeatureContext } from 'components/AccessResolvers/featureContext';

import { getLicenseList } from 'api/licenseService';
import { LicenseService } from 'services';

export const useGetLicenseList = () => {
  const {
    featureState: { authV3Enabled },
    corpAcctNbr,
  } = useContext(FeatureContext);

  return useQuery('licenseList', () =>
    getLicenseList(authV3Enabled, corpAcctNbr),
  );
};

export const useGetAssignedLicensesList = () =>
  useQuery('assignedLicensesList', () => LicenseService.getAssignedLicenses());
